export const TEXT_VARIANTS = [
    'display.l',
    'display.m',
    'display.s',
    'display.2xs',
    'heading.xl',
    'heading.l',
    'heading.m',
    'heading.s',
    'heading.xs',
    'body.2xl',
    'body.xl.default',
    'body.xl.underlined',
    'body.l.default',
    'body.l.underlined',
    'body.m.default',
    'body.m.underlined',
    'body.s.default',
    'body.s.underlined',
    'body.xs.default',
    'body.xs.underlined',
    'body.2xs.default',
    'body.2xs.underlined'
];
export const getTypographyStyles = (variant)=>{
    const textDecoration = variant.endsWith('underlined') ? 'underline' : 'none';
    const tokenName = variant.replace('.default', '').replace('.underlined', '');
    return {
        fontSize: tokenName,
        fontWeight: tokenName,
        lineHeight: tokenName,
        fontFamily: tokenName,
        textDecoration
    };
};

//# sourceMappingURL=utils.js.map